import React from "react";

function Features() {
    return (
        <section id="features" style={{ marginBottom: "3rem" }}>
            <div className="container">
                <div className="section-text">
                    <div className="section-text__title">
                        Some of the best features Of Our App!
                    </div>

                    <div className="row">
                        <div className="feature-box col-50">
                            <div className="section-text__title-small">Effortless Rent Collection</div>
                            <div className="section-text__body">
                                Say goodbye to the hassle of manual rent collection. Rentara allows you to
                                automate rent payments, track payment status, and send payment reminders to tenants, ensuring a seamless and timely collection process.              </div>
                        </div>

                        <div className="feature-box col-50">
                            <div className="section-text__title-small">Tenant Management Made Easy</div>
                            <div className="section-text__body">
                                Manage all your tenant information in one place. Keep track of lease agreements, contact details, and important documents. Communicate with tenants directly through the app, making it convenient for both parties.
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="feature-box col-50">
                            <div className="section-text__title-small">Property Maintenance Tracking</div>
                            <div className="section-text__body">
                                Stay on top of property maintenance and repair requests. Receive maintenance notifications, assign tasks to service providers, and track progress, all within the Rentara app.
                            </div>
                        </div>

                        <div className="feature-box col-50">
                            <div className="section-text__title-small">Financial Insights</div>
                            <div className="section-text__body">
                                Gain valuable insights into your rental business with comprehensive financial reports. Track rental income, expenses, and generate reports for accounting and tax purposes.                            </div>
                        </div>
                        <div className="feature-box col-50">
                            <div className="section-text__title-small">Legal Compliance</div>
                            <div className="section-text__body">
                                Simplify legal compliance with built-in features that help you stay updated with local rental regulations. Get reminders for lease renewals, document expiration dates, and ensure compliance with rental laws.                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Features;
